import { Injectable } from '@angular/core';
import {ConditionSearchModel} from '../../vss-ui.model';
import {ColumnType, OperatorSearch, TypeFieldSearch} from '../../vss-ui.enum';
import {FilterQuery} from '../../extensions/filter-query';
import * as moment from 'moment/moment';
import {Ultilities} from '../../extensions/ultilities';
import {TableAction, TableColum, TableFieldFilterModel} from './table.model';
import {FormItemType} from '../controls/vss-control.enum';
const FORMAT_DATE = 'DD/MM/YYYY HH:mm';

@Injectable({
  providedIn: 'root'
})
export class VssTableService {

  buildConditionsFilter(fieldFilters: TableFieldFilterModel[], objValues: any, isFilterJs = false): ConditionSearchModel[] {
    let conditions: ConditionSearchModel[] = [];
    fieldFilters.forEach(
      col => {
        const newConditions = [];
        try {
          const fieldName = col.fieldName;
          const typeCol = col.type;
          const valueCol = objValues[col.fieldValue || col.fieldName];

          switch (typeCol) {
            case ColumnType.DATE:
            case ColumnType.DATE_PICKER:
              newConditions?.push(FilterQuery.buildCondition(
                OperatorSearch.GREATER_EQUAL, fieldName, TypeFieldSearch.DATE, moment(valueCol).startOf('day').format('DD/MM/YYYY'))
              );
              newConditions?.push(FilterQuery.buildCondition(
                OperatorSearch.LOWER_EQUAL, fieldName, TypeFieldSearch.DATE, moment(valueCol).endOf('day').format('DD/MM/YYYY'))
              );
              break;
            case ColumnType.DATE_TIME_PICKER:
              newConditions?.push(FilterQuery.buildCondition(OperatorSearch.GREATER_EQUAL, fieldName, TypeFieldSearch.DATE, moment(valueCol).format(FORMAT_DATE)));
              newConditions?.push(FilterQuery.buildCondition(OperatorSearch.LOWER_EQUAL, fieldName, TypeFieldSearch.DATE, moment(valueCol).format(FORMAT_DATE)));
              break;
            case ColumnType.DATE_TIME_RANGE_PICKER:
            case ColumnType.DATE_RANGE_PICKER:
              const values = valueCol?.map((d: Date) => moment(d));
              newConditions?.push(FilterQuery.buildCondition(OperatorSearch.GREATER_EQUAL, fieldName, TypeFieldSearch.DATE,
                (typeCol == ColumnType.DATE_RANGE_PICKER ? values[0].startOf('day') : values[0]).format(FORMAT_DATE)));
              newConditions?.push(FilterQuery.buildCondition(OperatorSearch.LOWER_EQUAL, fieldName, TypeFieldSearch.DATE,
                (typeCol == ColumnType.DATE_RANGE_PICKER ? values[1].endOf('day') : values[1]).format(FORMAT_DATE)));
              break;
            case ColumnType.RANGE_NUMBER:
              newConditions?.push(FilterQuery.buildCondition(OperatorSearch.GREATER_EQUAL, fieldName, TypeFieldSearch.LONG, valueCol[0]));
              newConditions?.push(FilterQuery.buildCondition(OperatorSearch.LOWER_EQUAL, fieldName, TypeFieldSearch.LONG, valueCol[1]));
              break;
            case ColumnType.INPUT_NUMBER:
            case ColumnType.NUMBER:
              newConditions?.push(FilterQuery.buildCondition(OperatorSearch.EQUAL, fieldName, TypeFieldSearch.INT, valueCol));
              break;
            case ColumnType.SELECT:
            case ColumnType.SELECT_INT:
              if (col?.multiple) {
                newConditions?.push(
                  FilterQuery.buildCondition(
                    OperatorSearch.IN, fieldName,
                    typeCol == ColumnType.SELECT ? TypeFieldSearch.STRING : TypeFieldSearch.LONG,
                    valueCol.join(',')
                  )
                );
              } else {
                newConditions?.push(
                  FilterQuery.buildCondition(
                    OperatorSearch.EQUAL, fieldName,
                    typeCol == ColumnType.SELECT ? TypeFieldSearch.STRING : TypeFieldSearch.LONG,
                    valueCol
                  )
                );
              }
              break;
            default:
              let value = valueCol;
              let operator = OperatorSearch.LIKE;
              if (typeof value === 'object') {
                operator = OperatorSearch.IN;
                value = value?.join(',');
              } else {
                value = !isFilterJs ? Ultilities.replaceSpecial(value) : value;
              }
              newConditions?.push(FilterQuery.buildCondition(operator, fieldName, TypeFieldSearch.STRING, value?.trim()));
              break;
          }
        } catch (e) {
        }
        if (newConditions.length) {
          conditions = conditions?.concat(newConditions);
        }
      }
    );
    return conditions;
  }

formItemTypeToColumnType(type: FormItemType) {
    switch (type) {
      case FormItemType.INPUT_NUMBER:
        return ColumnType.NUMBER

      case FormItemType.CHECKBOX:
        return ColumnType.CHECKBOX

      case FormItemType.DATE_PICKER:
        return ColumnType.DATE_PICKER

      case FormItemType.DATE_RANGE_PICKER:
        return ColumnType.DATE_RANGE_PICKER

      case FormItemType.DATE_TIME_PICKER:
        return ColumnType.DATE_TIME_PICKER

      case FormItemType.DATE_TIME_RANGE_PICKER:
        return ColumnType.DATE_TIME_RANGE_PICKER

      case FormItemType.SELECT:
        return ColumnType.SELECT

      case FormItemType.TEXTAREA:
        return ColumnType.TEXTAREA

      case FormItemType.RANGE_NUMBER:
        return ColumnType.RANGE_NUMBER

      case FormItemType.TAGS:
        return ColumnType.TAG

      default:
        return ColumnType.TEXT
    }
  }
  convertActionOld(columns: TableColum[]) {
    columns.forEach(c => {
      if (c.name == 'action') {
        const mapOldAction = (k: string): TableAction => {
          switch (k) {
            case 'isEdit':
              return {
                html: '', icon: 'edit', key: 'edit', label: 'Sửa', rules: c.rulesAction?.isEdit || [], classes: 'text-blue'
              }
            case 'isView':
              return {
                html: '', icon: 'eye', key: 'view', label: 'Xem', rules: c.rulesAction?.isView || [], classes: 'text-blue'
              }
            case 'isCopy':
              return {
                html: '', icon: 'copy', key: 'copy', label: 'Sao chép', rules: c.rulesAction?.isCopy || [], classes: 'text-blue'
              }
            case 'isEditOfStatus':
              return {
                html: '', icon: 'edit', key: 'edit', label: 'Sửa', rules: c.rulesAction?.isEdit || [], fieldCheckShow: 'isActive', classes: 'text-blue'
              }
            case 'isRemove':
              return {
                html: '', icon: 'delete', key: 'delete', label: 'BUTTON.DELETE', rules: c.rulesAction?.isRemove || [], classes: 'text-danger'
              }
            case 'isDownloadFile':
              return {
                html: '', icon: 'download', key: 'downloadFile', label: 'Tải xuống', rules: c.rulesAction?.isDownloadFile || []
              }
            case 'isPlay':
              return {
                html: '', icon: 'play-circle', key: 'play', label: 'Chạy', rules: c.rulesAction?.isPlay || [], classes: 'text-blue'
              }
            case 'isPause':
              return {
                html: '', icon: 'pause', key: 'pause', label: 'Dừng/Tiếp tục', rules: c.rulesAction?.isPause || [], classes: 'text-blue'
              }
            case 'isInfo':
              return {
                html: '', icon: 'info-circle', key: 'info', label: 'Xem thông tin', rules: c.rulesAction?.isInfo || [], classes: 'text-blue'
              }
            default:
              return {
                html: '', icon: 'edit', key: 'edit', label: 'Sửa', rules: c.rulesAction?.isEdit || [], classes: 'text-blue'
              }
          }
        }
        c.listAction = (c.listAction || []).concat(c.action ? Object.keys(c.action).map(a => mapOldAction(a)) : [])
        c.action = {}
      }
    })
    return columns
  }
}
